// extracted by mini-css-extract-plugin
export default {"content":"FAQItem_content_PTfBk"};